exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "#companycolor {\n  font-size: 15px; }\n", "", {"version":3,"sources":["/Users/jean-philippe/_work/rs-webapp/rs-lightbox-old/client/app/pages/shared-pages/companycolor/companycolor.scss"],"names":[],"mappings":"AAAA;EACE,gBAAgB,EAAE","file":"companycolor.scss","sourcesContent":["#companycolor {\n  font-size: 15px; }\n"],"sourceRoot":""}]);

// exports
